import { useEffect, useState } from "react";
import { CircularProgress, Typography } from "@mui/material";
import {
  HeaderList,
  IHeaderListActions
} from "../../../Components/Header/HeaderList";
import { LoyaltyRule } from "../rules";
import LoyaltyRulesCard from "../components/LoyaltyRulesCard";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";

const LoyaltyRulesPage = () => {
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();

  const [rules, setRules] = useState<LoyaltyRule[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState<any>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);

  const fetchRules = async () => {
    try {
      const response: any = await callAPI("LoyaltyRule", Method.GET);
      if (response) {
        setRules(response);
      }
    } catch (error) {
      console.error("failed to retrieve data", error);
      showMessage("Something went wrong. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRules();
  }, []);

  const handleCreate = () => {
    navigate("/loyalty");
  };

  const handleEdit = (value: any) => {
    navigate(`/loyalty/${value.id}`);
  };

  const handleDelete = () => {
    setLoading(true);
    setTimeout(() => {
      fetchRules();
      showMessage("Loyalty rule deleted successfully!", "success");
    }, 1500);
  };

  const actions: IHeaderListActions[] = [
    {
      type: "icon",
      text: "Create Rule",
      size: "small",
      onClick: handleCreate,
      variant: "outlined",
      color: "primary",
      icon: <WSIcons.AddIcon />
    }
  ];

  return (
    <div style={{ padding: 24 }}>
      <HeaderList title="Loyalty Rules" type="card" actions={actions} />

      {loading ? (
        <CircularProgress />
      ) : rules.length > 0 ? (
        rules.map((value: any, i: number) => (
          <LoyaltyRulesCard
            key={i}
            rule={value}
            onEdit={() => handleEdit(value)}
            onDelete={() => {
              setPopupOpen(true);
              setSelectedId(value?.id);
            }}
            isActive={i === 0}
          />
        ))
      ) : (
        <Typography>No rules found.</Typography>
      )}

      {selectedId !== null && (
        <ConfirmationPopup
          apiUrl={"LoyaltyRule"}
          id={selectedId}
          confirmMessage="Are you sure you want to delete this rule?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={handleDelete}
          permanent
        />
      )}
    </div>
  );
};

export default LoyaltyRulesPage;
